import { ButtonOutline } from 'front-end/src/components'
import IconTick from 'front-end/src/components/common/icon/IconTick'
import IconX from 'front-end/src/components/common/icon/IconX'
import React from 'react'

import { Trans } from '@lingui/macro'

import * as quizUtils from '../utils'

export const QuizResult = ({ quizResponse, quizType }) => {
  if (!quizResponse) {
    return null
  }
  if (quizUtils.isFreeChoice(quizType)) {
    return null
  }

  if (quizUtils.isOpenChoice(quizType)) {
    return (
      <div className="QuizElement__submit__wrapper">
        <ButtonOutline isDisabled>
          <Trans>Answered</Trans>
        </ButtonOutline>
      </div>
    )
  } else {
    return (
      <div className="QuizElement__submit__wrapper">
        {quizResponse.is_correct ? (
          <div className={`QuizElement__submit completed-success`}>
            <IconTick /> <Trans>Correct</Trans>
          </div>
        ) : (
          <div className={`QuizElement__submit completed-failure`}>
            <IconX /> <Trans>Incorrect</Trans>
          </div>
        )}
      </div>
    )
  }
}
